import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

export default class FormModelInspector extends Component {

  constructor(props) {
    super(props);
    this.state = {showModel: true};
  }

  showModelChange = () => {
    this.setState(prevState => {
      return {showModel: !prevState.showModel};
    });
  };

  render() {
    const modelClone = {...this.props.formData};

    // if we shown the image data URL in the JSON, the whole site slows down to a crawl, so just shown the number of
    // images instead
    if (Array.isArray(modelClone.images)) {
      modelClone.images = modelClone.images.length;
    }
    return (
      <div>
        <div className="checkbox">
          <label>
            <input type="checkbox" onChange={this.showModelChange} checked={this.state.showModel}/>
            <FormattedMessage id="showFormModel" defaultMessage="Show Form Model"/>
          </label>
        </div>
        {
          this.state.showModel && <pre>{JSON.stringify(modelClone, null, 2)}</pre>
        }
      </div>
    )
  }
};

FormModelInspector.propTypes = {
  formData: PropTypes.object.isRequired,
};
